<template>
  <div class="group-detail">
    <h1 class="common__main-title">Timesheet update</h1>
    <div class="common__sub-title">Update</div>
    <b-tabs align="left" active-nav-item-class="tab-class" class="mb-4" v-model="tabIndex">

      <b-tab title-link-class="timesheet__update-tab" title="Lesson" active>
        <div class="content-wrapper">
          <DownloadLessons />
          <UploadLessons />
        </div>
      </b-tab>

      <b-tab title-link-class="timesheet__update-tab" title="Other">
        <div class="content-wrapper">
          <DownloadOthers />
          <UploadOthers />
        </div>
      </b-tab>
    </b-tabs>
    <div class="d-flex">
      <b-button pill variant="secondary" :to="{ name: 'Timesheets' }">
        Back
      </b-button>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import _ from 'lodash'
import DownloadLessons from '@/components/parts/timesheet/bulkUpdate/DownloadLessons.vue'
import UploadLessons from '@/components/parts/timesheet/bulkUpdate/UploadLessons.vue'
import DownloadOthers from '@/components/parts/timesheet/bulkUpdate/DownloadOthers.vue'
import UploadOthers from '@/components/parts/timesheet/bulkUpdate/UploadOthers.vue'

export default Vue.extend({
  components: {
    DownloadLessons,
    UploadLessons,
    DownloadOthers,
    UploadOthers,
  },

  data(): {
    tabIndex: number,
    } {
    return {
      tabIndex: 0,
    }
  },

  methods: {
    isSelectedLesson() {
      return this.tabIndex === 0
    },
    confirmUploadCsv() {
    },
  },
})
</script>

<style scoped>
.content-wrapper {
  background: #D8D8D8;
  padding: 20px 50px;
}
</style>

<style>
.timesheet__update-tab.nav-link {
  border: 0;
  background: #a9e9db;
  color: #fff;
  padding: 0.5rem 4rem;
}

.nav-tabs .timesheet__update-tab.nav-link.active {
  background: #1cc8a0;
  color: #fff;
  padding: 0.5rem 4rem;
}
</style>
